import React, { useState, useEffect } from 'react';
import { Container, Typography, TextField, Button, MenuItem, Alert, Stack } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import pagamentoApi from '../../api/pagamentoApi'; // dovrai creare questo api
import contrattoApi from '../../api/contrattoApi';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function PagamentoCreatePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const contrattoId = searchParams.get('contrattoId');
  const [contratto, setContratto]=useState({});
  const [loading, setLoading] = useState(true);

  const [err, setErr] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const contrattoRes = await contrattoApi.get(contrattoId);
        setContratto(contrattoRes.data);
        console.log("contratto",contrattoRes.data);
        form.importo=contratto.canoneAnnuo;
      } catch (e) {
        setErr(e.response?.data || e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [contrattoId]);
if(!contratto) return <div>Loading...</div>;
  const [form, setForm] = useState({
    contrattoId,
    stato: 'CREATO',
    metodo: 'CARTA',
    importo: contratto.canoneAnnuo,
    riferimentoEsterno: '',
    dataPagamento: ''
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await pagamentoApi.create(form); // POST al backend
      navigate(`/contratti/${contrattoId}/edit`); // ritorna al dettaglio contratto
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container maxWidth="sm">
    <BackButtonDesktop />
      <Typography variant="h5" sx={{ mb: 2 }}>Nuovo Pagamento</Typography>
      {err && <Alert severity="error" sx={{ mb: 2 }}>{String(err)}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          select
          fullWidth
          label="Stato"
          value={form.stato}
          onChange={e => setForm({ ...form, stato: e.target.value })}
          sx={{ mb: 2 }}
        >
          {['CREATO','IN_ATTESA','IN_PROCESSO','VERIFICATO','PAGATO','FALLITO'].map(s => (
            <MenuItem key={s} value={s}>{s}</MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          label="Metodo"
          value={form.metodo}
          onChange={e => setForm({ ...form, metodo: e.target.value })}
          sx={{ mb: 2 }}
        >
          {['CARTA','BONIFICO','PAYPAL'].map(m => (
            <MenuItem key={m} value={m}>{m}</MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          type="number"
          label="Importo"
          value={form.importo}
          onChange={e => setForm({ ...form, importo: e.target.value })}
          sx={{ mb: 2 }}
          required
        />

        <TextField
          fullWidth
          label="Riferimento Esterno"
          value={form.riferimentoEsterno}
          onChange={e => setForm({ ...form, riferimentoEsterno: e.target.value })}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          type="date"
          label="Data Pagamento"
          InputLabelProps={{ shrink: true }}
          value={form.dataPagamento}
          onChange={e => setForm({ ...form, dataPagamento: e.target.value })}
          sx={{ mb: 2 }}
        />

        <Stack direction="row" spacing={2}>
          <Button type="submit" variant="contained">Salva Pagamento</Button>
          <Button variant="text" onClick={() => navigate(`/contratti/${contrattoId}/edit`)}>Annulla</Button>
        </Stack>
      </form>
    </Container>
  );
}